export default __webpack_public_path__ + "static/logo-cc0563a4a2e386c5519fe55f911a79a6.svg";